import React from 'react';
import { Breadcrumbs } from '../components/ui/Breadcrumbs';
interface PrivacyPolicyPageProps {
  onNavigate: (page: string) => void;
}
export function PrivacyPolicyPage({
  onNavigate
}: PrivacyPolicyPageProps) {
  return <div className="min-h-screen bg-slate-50 pb-24" data-id="element-23675">
      <div className="bg-white border-b border-slate-200 pt-6 pb-12" data-id="element-23676">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-23677">
          <Breadcrumbs items={[{
          label: 'Главная',
          onClick: () => onNavigate('home')
        }, {
          label: 'Политика конфиденциальности'
        }]} className="mb-8" data-id="element-23678" />
          <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4" data-id="element-23679">
            Политика конфиденциальности
          </h1>
          <p className="text-slate-500" data-id="element-23680">Последнее обновление: 15 мая 2026 г.</p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-23681">
        <div className="bg-white rounded-2xl p-8 sm:p-12 border border-slate-200 shadow-sm prose prose-slate max-w-none" data-id="element-23682">
          <h2 data-id="element-23683">1. Общие положения</h2>
          <p data-id="element-23684">
            Настоящая Политика конфиденциальности (далее — «Политика»)
            определяет порядок обработки и защиты персональных данных
            пользователей сервиса Astriqo (далее — «Сервис»). Мы с уважением
            относимся к конфиденциальности ваших данных и прилагаем все усилия
            для их защиты.
          </p>

          <h2 data-id="element-23685">2. Какие данные мы собираем</h2>
          <p data-id="element-23686">
            Для предоставления астрологических услуг мы собираем следующие
            данные:
          </p>
          <ul data-id="element-23687">
            <li data-id="element-23688">
              <strong data-id="element-23689">Регистрационные данные:</strong> имя, адрес электронной
              почты, номер телефона.
            </li>
            <li data-id="element-23690">
              <strong data-id="element-23691">Астрологические данные:</strong> дата, точное время и
              место рождения (необходимы для расчета натальной карты).
            </li>
            <li data-id="element-23692">
              <strong data-id="element-23693">Технические данные:</strong> IP-адрес, тип браузера,
              данные файлов cookie.
            </li>
          </ul>

          <h2 data-id="element-23694">3. Использование данных</h2>
          <p data-id="element-23695">Мы используем ваши данные исключительно для следующих целей:</p>
          <ul data-id="element-23696">
            <li data-id="element-23697">Генерация персональных астрологических отчетов.</li>
            <li data-id="element-23698">Организация консультаций с астрологами платформы.</li>
            <li data-id="element-23699">Улучшение качества работы Сервиса.</li>
            <li data-id="element-23700">
              Отправка важных уведомлений (например, о готовности отчета).
            </li>
          </ul>

          <h2 data-id="element-23701">4. Передача данных третьим лицам</h2>
          <p data-id="element-23702">
            Мы не продаем и не передаем ваши персональные данные третьим лицам
            для маркетинговых целей. Ваши астрологические данные (дата, время,
            место рождения) могут быть переданы выбранному вами астрологу
            исключительно для проведения оплаченной консультации.
          </p>

          <h2 data-id="element-23703">5. Безопасность данных</h2>
          <p data-id="element-23704">
            Мы используем современные методы шифрования и защиты данных для
            предотвращения несанкционированного доступа. Все платежи
            обрабатываются через защищенные шлюзы сертифицированных платежных
            систем.
          </p>

          <h2 data-id="element-23705">6. Ваши права</h2>
          <p data-id="element-23706">Вы имеете право в любой момент:</p>
          <ul data-id="element-23707">
            <li data-id="element-23708">Запросить копию всех ваших данных, хранящихся в Сервисе.</li>
            <li data-id="element-23709">
              Отредактировать или удалить свои данные через настройки Личного
              кабинета.
            </li>
            <li data-id="element-23710">Отозвать согласие на обработку персональных данных.</li>
          </ul>

          <h2 data-id="element-23711">7. Контакты</h2>
          <p data-id="element-23712">
            Если у вас есть вопросы по поводу настоящей Политики
            конфиденциальности, пожалуйста, свяжитесь с нами по адресу:{' '}
            <a href="mailto:privacy@astriqo.com" data-id="element-23713">privacy@astriqo.com</a>.
          </p>
        </div>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm" data-id="element-23714">
          <button onClick={() => onNavigate('terms')} className="text-indigo-600 hover:text-indigo-800 font-medium transition-colors" data-id="element-23715">
            Пользовательское соглашение →
          </button>
          <button onClick={() => onNavigate('contact')} className="text-slate-500 hover:text-slate-700 font-medium transition-colors" data-id="element-23716">
            Есть вопросы? Свяжитесь с нами
          </button>
        </div>
      </div>
    </div>;
}